import React from 'react'
import styled from 'styled-components'

import ComponentCard from 'components/Card'

import { color } from 'styles/colors'

type Props = {
  title: string
  icon?: string
  iconNode?: React.ReactNode
  onClick?: (tab: string) => void
  children: React.ReactNode
  iconStyle?: React.CSSProperties
  titleStyle?: React.CSSProperties
  headerActions?: React.ReactNode
  className?: string
}

const Card = ({ title, icon, iconNode, onClick, iconStyle, titleStyle, headerActions, children, className }: Props) => {
  return (
    <S.Container
      className={className}
      onClick={() => onClick && onClick(title)}
      hasOnClick={!!onClick}
    >
      <S.TopRow>
        {icon && (
          <S.Icon
            role="img"
            aria-hidden="true"
            style={{ backgroundImage: `url(${icon})`, ...iconStyle }}
          />
        )}
        {iconNode && iconNode}

        <S.Title style={titleStyle}>{title}</S.Title>

        {title === 'Health' && (
          <S.HealthHeartbeatIcon
            role="img"
            aria-hidden="true"
            style={{
              backgroundImage: `url(/img/ekg_pulse_${icon?.split('_').pop()})`
            }}
          />
        )}

        {headerActions && <S.HeaderActions>{headerActions}</S.HeaderActions>}
      </S.TopRow>

      {children}
    </S.Container>
  )
}

Card.ItemLabel = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`
Card.ItemValue = styled.div`
  margin-bottom: 15px;
`

export default Card

const S = {
  Container: styled(ComponentCard).withConfig({
    shouldForwardProp: (prop) => prop !== 'hasOnClick'
  })<{ hasOnClick: boolean }>`
    cursor: ${({ hasOnClick }) => hasOnClick ? 'pointer' : 'default'};
    border: 1px solid ${color('border')};
    border-radius: 20px;
    
  `,
  TopRow: styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  `,
  HeaderActions: styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    align-self: center;
    gap: 4px;
  `,
  Icon: styled.span`
    display: inline-block;
    width: 30px;
    height: 30px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 5px;
  `,
  Title: styled.h3`
    text-transform: capitalize;
    font-size: 22px;
    margin-bottom: 0;
    color: ${color('primaryText')};
  `,
  HealthHeartbeatIcon: styled.span`
    display: inline-block;
    width: 75px;
    height: 30px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 10px;
  `
}
